import { NumberInput } from 'components/NumberInput/NumberInput'
import { translate } from 'i18n/i18n'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect } from 'react'
import { validateStatusErrorHelper } from '../../../../../_utils/validateStatusErrorHelper'
import type { Rule } from '../../../../_types'
import { getErrorStyle } from '../../../../_utils/getErrorStyle'
import { AlertsValidators, isNumberOrNumericString } from '../../../../AlertValidators/AlertValidators'
import { ErrorTextWrapper } from '../../../../components/ErrorTextWrapper'
import { TranslateComponentWrapper } from '../../../../components/TranslateComponentWrapper'
import { TranslatePhraseWrapper } from '../../../../components/TranslatePhraseWrapper'
import { AlertsSettings, unitTempDisplay } from '../../../../settings/alertSettings'
import { alertRulesObjectFromArray } from '../../_utils/alertRulesObjectFromArray'
import { helpTextErrorHelper } from '../../_utils/helpTextErrorHelper'
import { updateAlertRules } from '../../_utils/updateAlertRules'

export const WetBulbThreshold = ({
  rules,
  setRules,
  setThresholdIsValid,
  triedToSubmit,
}: {
  rules: Rule[]
  setRules: Dispatch<SetStateAction<Rule[]>>
  setThresholdIsValid: Dispatch<SetStateAction<boolean>>
  triedToSubmit: boolean
}) => {
  useEffect(() => {
    if (!rules || !rules.length) setRules(AlertsSettings.emptyRules.wetBulb)
  })

  const { wetBulb: wetBulbRule } = alertRulesObjectFromArray(rules)
  const wetBulbTemperature = wetBulbRule ? wetBulbRule.value : null
  // check if user-enterable fields are dirty
  const wetBulbTemperatureIsDirty = wetBulbTemperature !== null || triedToSubmit
  // validate the user-entered values
  const wetBulbTemperatureError = AlertsValidators.temperatureWetBulb({ temperature: wetBulbTemperature })

  // attach a status
  const wetBulbTemperatureValidateStatus = validateStatusErrorHelper(
    wetBulbTemperatureIsDirty && !!wetBulbTemperatureError,
  )

  // attach an error message
  const wetBulbTemperatureHelp = helpTextErrorHelper(wetBulbTemperatureIsDirty && wetBulbTemperatureError)
  const errorStyle = getErrorStyle()

  // update the rules upon changes
  useEffect(() => {
    setThresholdIsValid(!wetBulbTemperatureError)
  }, [wetBulbTemperature])

  const unitTemp = unitTempDisplay()

  return (
    <>
      <TranslatePhraseWrapper>
        <translate.Phrases.banyanApp
          k="Send alert when wet bulb temperature is less than or equal to <numberInput/> {{unitTemp}}"
          v={{ unitTemp }}
          c={{
            numberInput: (
              <TranslateComponentWrapper>
                <NumberInput
                  onChange={(value) =>
                    updateAlertRules({ rules, setRules, rulesToChange: { wetBulb: { value } } })
                  }
                  css={{ width: 80, margin: '0 5px' }}
                  classNames={{ input: wetBulbTemperatureValidateStatus ? errorStyle : undefined }}
                  value={isNumberOrNumericString(wetBulbTemperature) ? Number(wetBulbTemperature) : ''}
                  decimalScale={10}
                />
                <div />
              </TranslateComponentWrapper>
            ),
          }}
        />
      </TranslatePhraseWrapper>
      {wetBulbTemperatureHelp && <ErrorTextWrapper>{wetBulbTemperatureHelp}</ErrorTextWrapper>}
    </>
  )
}
